/**
 * Hook: Notification Center verileri
 * Bugünün özeti, son chat mesajları, aktif agent'lar, FLZ kazanç
 * 30s polling
 */
import { useEffect, useState } from 'react'
import { API_URL, apiFetch } from '../../../config/api'

export interface RecentMessage {
  id: number
  agent_name: string
  message: string
  created_at: string
}

export interface ActiveAgent {
  id: number
  agent_name: string
  status: 'idle' | 'thinking' | 'running'
  last_activity: string
}

export interface NotificationCenterData {
  recentMessages: RecentMessage[]
  activeAgents: ActiveAgent[]
  flzToday: number
  totalTasks: number
  completedTasks: number
  loading: boolean
}

export function useNotificationCenterData(): NotificationCenterData {
  const [recentMessages, setRecentMessages] = useState<RecentMessage[]>([])
  const [activeAgents, setActiveAgents] = useState<ActiveAgent[]>([])
  const [flzToday, setFlzToday] = useState(0)
  const [totalTasks] = useState(0)
  const [completedTasks] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) { setLoading(false); return }

    const load = async () => {
      try {
        const [msgRes, agentRes, walletRes] = await Promise.allSettled([
          apiFetch(`${API_URL}/api/flzhub/messages?limit=3`).then(r => r.json()),
          apiFetch(`${API_URL}/api/flzhub/agents`).then(r => r.json()),
          apiFetch(`${API_URL}/api/wallet/balance`).then(r => r.json()),
        ])

        if (msgRes.status === 'fulfilled') {
          const msgs = (msgRes.value as { messages?: RecentMessage[] })?.messages ?? []
          setRecentMessages(msgs.slice(0, 3))
        }

        if (agentRes.status === 'fulfilled') {
          const agents = (agentRes.value as { agents?: ActiveAgent[] })?.agents ?? []
          setActiveAgents(agents.slice(0, 5).map(a => ({ ...a, status: 'idle' as const, last_activity: '' })))
        }

        if (walletRes.status === 'fulfilled') {
          const d = walletRes.value as { wallet_balance?: number; today_earnings?: number } | null
          setFlzToday(d?.today_earnings ?? 0)
        }
      } catch { /* silent */ }
      finally { setLoading(false) }
    }

    void load()
    const interval = setInterval(() => { void load() }, 30000)
    return () => clearInterval(interval)
  }, [])

  return { recentMessages, activeAgents, flzToday, totalTasks, completedTasks, loading }
}
